import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ModalStyle } from '@luggagehero/core';
import {
  PickUpActionBaseComponent,
  ShowReceiptActionBaseComponent,
  ValidateBookingActionBaseComponent,
} from '@luggagehero/features/bookings';
import { ViewImageComponent } from '@luggagehero/web/features/ui';

import { PickUpActionComponent } from '../pick-up-action/pick-up-action.component';
import { ShowReceiptActionComponent } from '../show-receipt-action/show-receipt-action.component';

@Component({
  selector: 'lh-validate-booking-action',
  templateUrl: './validate-booking-action.component.html',
  styleUrls: ['./validate-booking-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidateBookingActionComponent extends ValidateBookingActionBaseComponent {
  protected get pickUpActionComponentType(): Type<PickUpActionBaseComponent> {
    return PickUpActionComponent;
  }
  protected get showReceiptActionComponentType(): Type<ShowReceiptActionBaseComponent> {
    return ShowReceiptActionComponent;
  }

  public showLuggageImage(e: Event): void {
    if (!this.luggageImage) {
      return;
    }

    e.stopPropagation();
    void this.modalService.show({
      component: ViewImageComponent,
      componentState: {
        image: this.luggageImage,
        imageSize: 'large',
      },
      style: ModalStyle.Alert,
      autoWidth: 'md',
    });
  }
}
